module.exports = "/images/acrobat_icon.png?ba551be5cdb944f065fa7b0ec912721a";